// Metaobject-based Bundle System for Product Detail Page
var option_data_fields_arr = [];
var option_data_fields = [];

// Performance optimization objects for metaobject-based bundles
window.OptimizedBundleManager = window.OptimizedBundleManager || {
    // Optimized batch cart addition for metaobject bundles
    async batchAddToCart(cartItems) {
        const startTime = performance.now();
        
        // Filter out items that have already failed to prevent infinite loops
        const filteredItems = cartItems.filter(item => {
            const itemKey = `${item.id}_${item.properties?._boldBuilderId || 'none'}`;
            return !window.failedCartItems || !window.failedCartItems.has(itemKey);
        });
        
        if (filteredItems.length === 0) {
            console.warn('All metaobject bundle items have previously failed, skipping to prevent infinite loop');
            return { success: false, error: 'All items previously failed' };
        }
        
        try {
            // Use Shopify's batch add endpoint
            const response = await fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ items: filteredItems })
            });

            const endTime = performance.now();
            const duration = endTime - startTime;

            if (!response.ok) {
                // Try to get error details
                let errorMessage = `Batch add failed: ${response.status}`;
                try {
                    const errorData = await response.json();
                    if (errorData.description) {
                        errorMessage = errorData.description;
                    } else if (errorData.message) {
                        errorMessage = errorData.message;
                    }
                } catch (e) {
                    // If JSON parsing fails, use status text
                    errorMessage = `Batch add failed: ${response.status} ${response.statusText}`;
                }
                
                // Only mark as failed if it's a permanent error (not 429 rate limit)
                if (response.status !== 429) {
                    if (!window.failedCartItems) {
                        window.failedCartItems = new Set();
                    }
                    filteredItems.forEach(item => {
                        const itemKey = `${item.id}_${item.properties?._boldBuilderId || 'none'}`;
                        window.failedCartItems.add(itemKey);
                    });
                }
                
                throw new Error(errorMessage);
            }

            const result = await response.json();
            
            // Clear failed items on success
            if (window.failedCartItems) {
                filteredItems.forEach(item => {
                    const itemKey = `${item.id}_${item.properties?._boldBuilderId || 'none'}`;
                    window.failedCartItems.delete(itemKey);
                });
            }
            
            
            return { success: true, result: result, duration: duration };
            
        } catch (error) {
            const endTime = performance.now();
            const duration = endTime - startTime;

            console.error('OptimizedBundleManager batch add failed:', error);
            return { success: false, error: error, duration: duration };
        }
    },

    // Add bundle to cart with parent item (optimized with parent quantity multiplier)
    async addBundleToCart(formData, parentResponse) {
        const bundleVariantIds = formData.get('properties[_boldVariantIds]');
        const bundleVariantQtys = formData.get('properties[_boldVariantQtys]');
        const bundleBuilderId = formData.get('properties[_boldBuilderId]');
        const bundleProductIds = formData.get('properties[_boldProductIds]');
        const bundleVariantNames = formData.get('properties[_boldVariantNames]');
        const parentQuantity = parseInt(formData.get('quantity') || '1'); // Get parent quantity

        if (!bundleVariantIds || !bundleVariantQtys || !bundleBuilderId) {
            return { success: false, error: 'Missing bundle data' };
        }

        const variantIds = bundleVariantIds.split(',').map(id => id.trim());
        const quantities = bundleVariantQtys.split(',').map(qty => parseInt(qty.trim()) || 1);
        const productIds = bundleProductIds ? bundleProductIds.split(',').map(id => id.trim()) : [];
        const variantNames = bundleVariantNames ? bundleVariantNames.split(',').map(name => name.trim()) : [];

        // Multiply child quantities by parent quantity
        const cartItems = variantIds.map((variantId, index) => ({
            id: parseInt(variantId),
            quantity: quantities[index] * parentQuantity, // Apply parent quantity multiplier
            properties: {
                '_boldBuilderId': bundleBuilderId,
                '_boldIsChildItem': 'true',
                '_boldVariantName': variantNames[index] || '',
                '_boldProductId': productIds[index] || '',
                '_bundleSource': 'metaobject'
            }
        }));

        return await this.batchAddToCart(cartItems);
    }
};

// Initialize failed items tracking
window.failedCartItems = window.failedCartItems || new Set();

// Handle bundle choose button clicks
document.addEventListener("click", function (event) {
    if (event.target.matches("#bundle-choose")) {
        event.target.classList.add("hide-bundle-choose");

        var form = event.target.closest("form");
        if (form) {
            var bundleOptions = form.querySelector(".bold_option_set");
            if (bundleOptions) {
                bundleOptions.classList.remove("hide-bundle-choose");
            }
            var addToCartBtn = form.querySelector(".product-form--atc-button");
            if (addToCartBtn) {
                addToCartBtn.classList.remove("hide-bundle-choose");
            }
        }
    }
});

/**
 * Clean option name by removing identifier suffix (e.g., "| EK244M")
 * @param {string} optionName - Original option name (e.g., "Piston Ring Set | EK244")
 * @returns {string} Cleaned option name (e.g., "Piston Ring Set")
 */
function cleanOptionName(optionName) {
    if (!optionName) return optionName;
    return optionName.split('|')[0].trim();
}

/**
 * Convert string to handleized format for property names
 * @param {string} name - Name to handleize
 * @returns {string} Handleized name (e.g., "piston-ring-set")
 */
function handleize(name) {
    return name
        .toLowerCase()
        .replace(/\s+/g, '-')
        .replace(/[^\w\-]+/g, '')
        .replace(/\-\-+/g, '-')
        .replace(/^-+/, '')
        .replace(/-+$/, '');
}

/**
 * Sort bundle options in predefined order
 */
function sortBundleOptions(options) {
    const orderPriority = {
        'piston set': 1,
        'piston ring set': 2,
        'main bearing set': 3,
        'main bearings set': 3,
        'rod bearing set': 4
    };
    
    return options.slice().sort((a, b) => {
        const nameA = cleanOptionName(a.bundle_option_name || '').toLowerCase();
        const nameB = cleanOptionName(b.bundle_option_name || '').toLowerCase();
        
        let priorityA = 999;
        let priorityB = 999;
        
        for (const [key, priority] of Object.entries(orderPriority)) {
            if (nameA.includes(key)) priorityA = Math.min(priorityA, priority);
            if (nameB.includes(key)) priorityB = Math.min(priorityB, priority);
        }
        
        return priorityA - priorityB;
    });
}

// Initialize metaobject-based bundle system
document.addEventListener('DOMContentLoaded', function() {
    // Use setTimeout to ensure all other scripts have run
    setTimeout(function() {
        initializeMetaobjectBundleSystem();
    }, 100);
});

// Also try initializing if DOM is already loaded
if (document.readyState === 'complete' || document.readyState === 'interactive') {
    setTimeout(function() {
        initializeMetaobjectBundleSystem();
    }, 100);
}

function initializeMetaobjectBundleSystem() {
    const bundleStock = document.querySelector(".bundle_stock");
    const productInfo = document.querySelector(".product-details[attr-prod-id]");
    const shopProductIdInput = document.querySelector(".shop_product_id");

    if (bundleStock && bundleStock.value == "instock") {
        // Get product ID from attr-prod-id or shop_product_id input
        var parent_bundle_id = null;
        if (productInfo) {
            parent_bundle_id = productInfo.getAttribute("attr-prod-id");
        } else if (shopProductIdInput) {
            parent_bundle_id = shopProductIdInput.value;
        }
        
        if (!parent_bundle_id) {
            console.warn('Could not find product ID for bundle initialization');
            return;
        }

        // Hide add to cart button initially
        var addToCartBtn = document.querySelector(".product-form--atc-button");
        if (addToCartBtn) {
            addToCartBtn.style.display = "none";
        }

        // Get bundle data from metaobject using new metafield approach
        const bundleData = window.bundleMetaobjectData && window.bundleMetaobjectData[parent_bundle_id];
        
        if (bundleData) {
            processMetaobjectBundleData(bundleData, parent_bundle_id);
        } else {
            console.warn('No bundle data found for product:', parent_bundle_id);
            // Enable add to cart button if no bundle data
            if (addToCartBtn) {
                addToCartBtn.style.display = "";
            }
        }
    }
}

function processMetaobjectBundleData(data, parent_bundle_id) {
    
    var option_set = "";
    option_set += '<div class="bold_option_set">'; // Removed hide-bundle-choose - options should be visible by default
    var options = '';
    var shop_product_id = parseInt(parent_bundle_id);
    option_data_fields_arr[shop_product_id] = data;
    option_data_fields = data;

    if (data && data.bundle_options && data.bundle_options[0] && data.bundle_options[0].options) {
        var options_data = sortBundleOptions(data.bundle_options[0].options);
        var name_attributes = [];
        var product_attributes = [];
        var varient_attributes = [];
        var price_attributes = [];
        var qty_attributes = [];
        var product_features_html = "";

        for (var b = 0; b < options_data.length; b++) {
            var option = options_data[b];
            var required_type = "";
            if (option.is_required == 1) {
                required_type = "required";
            }

            if (option.options_values && option.options_values.length > 1) {
                // Multiple variants - show as dropdown
                const cleanedOptionName = cleanOptionName(option.bundle_option_name);
                const handleizeName = handleize(cleanedOptionName);
                options += '<div class="bold_option bold_option_dropdown"><label>';
                options += '<span class="bold_option_title">' + cleanedOptionName + '</span>';
                options += '<span class="bold_option_element"><select id="dd_select_' + b + '" attr-name="' + cleanedOptionName + '" name="properties[' + cleanedOptionName + ']" data-original-name="' + option.bundle_option_name + '" data-bundle-option-id="' + (option.bundle_option_id || '') + '" class="bundle_option_select dd_' + option.bundle_option_set_id + '_' + option.bundle_option_id + '" ' + required_type + '>';
                
                // Add default option
                options += '<option value="">-- Choose ' + cleanOptionName(option.bundle_option_name) + ' --</option>';
                
                // Add variant options (data-qty from Bundle Item Quantity for cart quantities)
                for (var v = 0; v < option.options_values.length; v++) {
                    var variant = option.options_values[v];
                    if (variant.available !== false) {
                        var selected = (variant.is_default == 1) ? 'selected' : '';
                        var variantQty = (variant.qty != null && variant.qty !== '') ? String(variant.qty) : '1';
                        options += '<option value="' + variant.option_value + '" data-option_value_key="' + v + '" data-variant-id="' + variant.varient_id + '" data-product-id="' + variant.product_id + '" data-price="' + variant.price + '" data-qty="' + variantQty + '" data-original-value="' + variant.option_value + '" ' + selected + '>' + cleanOptionName(variant.option_value) + '</option>';
                    }
                }
                
                options += '</select></span></label></div>';
            } else if (option.options_values && option.options_values.length === 1) {
                // Single variant - create dropdown (visible or hidden based on option type)
                var variant = option.options_values[0];
                if (variant.available !== false) {
                    const cleanedOptionName = cleanOptionName(option.bundle_option_name);
                    const handleizeName = handleize(cleanedOptionName);
                    const required_type = (option.is_required == 1) ? "required" : "";
                    
                    // Define which single-variant options should be visible
                    const visibleSingleVariantOptions = [
                        'Piston Set', 'Piston Ring Set', 'Main Bearing Set', 'Rod Bearing Set'
                    ];
                    
                    const shouldBeVisible = visibleSingleVariantOptions.some(visibleOption => 
                        cleanedOptionName.toLowerCase().includes(visibleOption.toLowerCase())
                    );
                    
                    var variantQty = (variant.qty != null && variant.qty !== '') ? String(variant.qty) : '1';
                    if (shouldBeVisible) {
                        // Create visible dropdown for important single-variant options
                        options += '<div class="bold_option bold_option_dropdown"><label>';
                        options += '<span class="bold_option_title">' + cleanedOptionName + '</span>';
                        options += '<span class="bold_option_element"><select id="dd_select_' + b + '" attr-name="' + cleanedOptionName + '" name="properties[' + cleanedOptionName + ']" data-original-name="' + option.bundle_option_name + '" data-bundle-option-id="' + (option.bundle_option_id || '') + '" class="bundle_option_select dd_' + option.bundle_option_set_id + '_' + option.bundle_option_id + '" ' + required_type + '>';
                        options += '<option value="">-- Choose ' + cleanOptionName(option.bundle_option_name) + ' --</option>';
                        options += '<option value="' + variant.option_value + '" data-option_value_key="0" data-variant-id="' + variant.varient_id + '" data-product-id="' + variant.product_id + '" data-price="' + variant.price + '" data-qty="' + variantQty + '" data-original-value="' + variant.option_value + '" selected>' + cleanOptionName(variant.option_value) + '</option>';
                        options += '</select></span></label></div>';
                    } else {
                        // Create hidden dropdown for other single-variant options (like reference side)
                        options += '<div class="bold_option bold_option_dropdown" style="display: none;"><label>';
                        options += '<span class="bold_option_title">' + cleanedOptionName + '</span>';
                        options += '<span class="bold_option_element"><select id="dd_select_' + b + '" style="display: none;" name="properties[' + cleanedOptionName + ']" data-original-name="' + option.bundle_option_name + '" data-bundle-option-id="' + (option.bundle_option_id || '') + '" class="bundle_option_select dd_' + option.bundle_option_set_id + '_' + option.bundle_option_id + '" ' + required_type + '>';
                        options += '<option value="">-- Choose ' + cleanOptionName(option.bundle_option_name) + ' --</option>';
                        options += '<option value="' + variant.option_value + '" data-option_value_key="0" data-variant-id="' + variant.varient_id + '" data-product-id="' + variant.product_id + '" data-price="' + variant.price + '" data-qty="' + variantQty + '" data-original-value="' + variant.option_value + '" selected>' + cleanOptionName(variant.option_value) + '</option>';
                        options += '</select></span></label></div>';
                        
                        // Add to initial attributes for hidden single-variant options
                        name_attributes.push(variant.option_value);
                        product_attributes.push(variant.product_id);
                        varient_attributes.push(variant.varient_id);
                        qty_attributes.push(variant.qty || '1');
                        shop_product_id += parseInt(variant.varient_id);
                        price_attributes.push(variant.price.toString().replace(".", ""));
                        product_features_html += "<li>" + cleanOptionName(variant.option_value) + "</li>";
                    }
                }
            }
        }
        
        // Generate bundle attributes strings
        if (name_attributes.length > 0) {
            name_attributes = name_attributes.join(",").trim();
        }
        if (product_attributes.length > 0) {
            product_attributes = product_attributes.join(",").trim();
        }
        if (varient_attributes.length > 0) {
            varient_attributes = varient_attributes.join(",").trim();
        }
        if (qty_attributes.length > 0) {
            qty_attributes = qty_attributes.join(",").trim();
        }
        if (price_attributes.length > 0) {
            price_attributes = price_attributes.join(",").trim().replace(".", "");
        }
        
        if (options != "") {
            option_set += options;
        }
        
        var total_html = '<div class="bold_option_total">' +
            '<input type="hidden" name="properties[_boldVariantNames]" data-property-name="_boldVariantNames" value="' + name_attributes + '">' +
            '<input type="hidden" name="properties[_boldVariantIds]" data-property-name="_boldVariantIds" value="' + varient_attributes + '">' +
            '<input type="hidden" name="properties[_boldProductIds]" data-property-name="_boldProductIds" value="' + product_attributes + '">' +
            '<input type="hidden" name="properties[_boldVariantPrices]" data-property-name="_boldVariantPrices" value="0">' +
            '<input type="hidden" name="properties[_boldVariantQtys]" data-property-name="_boldVariantQtys" value="' + qty_attributes + '">' +
            '<input type="hidden" name="properties[_boldBuilderId]" data-property-name="_boldBuilderId" value="' + shop_product_id + '">' +
            '</div>';
        option_set += total_html + '</div>';
    }

    // Inject bundle options into the product form
    var boldOptionsContainer = document.querySelector(".bold_options.bold_options_loaded");
    if (boldOptionsContainer) {
        boldOptionsContainer.innerHTML = option_set;
        // Ensure the bundle options container is visible
        boldOptionsContainer.style.display = "";
        boldOptionsContainer.style.visibility = "visible";
        
        var boldOptionSet = boldOptionsContainer.querySelector(".bold_option_set");
        if (boldOptionSet) {
            boldOptionSet.classList.remove("hide-bundle-choose");
            boldOptionSet.style.display = "";
            boldOptionSet.style.visibility = "visible";
            
            // Also ensure all visible dropdown options are shown
            var visibleDropdowns = boldOptionSet.querySelectorAll('.bold_option_dropdown:not([style*="display: none"])');
            visibleDropdowns.forEach(function(dropdown) {
                dropdown.style.display = "";
                dropdown.style.visibility = "visible";
            });
        } else {
            console.warn('Could not find .bold_option_set after injection');
        }
    } else {
        // Create container if it doesn't exist
        var formArea = document.querySelector("[data-product-form-area]");
        if (formArea) {
            var newContainer = document.createElement("div");
            newContainer.className = "bold_options bold_options_loaded";
            newContainer.innerHTML = option_set;
            var atcButton = formArea.querySelector(".product-form--atc");
            if (atcButton) {
                formArea.insertBefore(newContainer, atcButton);
            } else {
                formArea.appendChild(newContainer);
            }
            // Ensure visibility
            var boldOptionSet = newContainer.querySelector(".bold_option_set");
            if (boldOptionSet) {
                boldOptionSet.classList.remove("hide-bundle-choose");
                boldOptionSet.style.display = "";
                boldOptionSet.style.visibility = "visible";
            }
        } else {
            console.error('Could not find [data-product-form-area] to inject bundle options');
        }
    }

    var addToCartButton = document.querySelector(".product-form--atc-button");
    if (addToCartButton) {
        addToCartButton.style.display = "";
    } else {
        console.warn('Could not find .product-form--atc-button');
    }
    

    // Update product features list if it exists
    var productFeaturesList = document.querySelector(".product-features ul");
    if (productFeaturesList && product_features_html) {
        productFeaturesList.innerHTML = product_features_html;
    }
}

// Handle bundle option changes
document.addEventListener("change", (event) => {
    // Check if we're on a product page with bundle options
    const productDetails = document.querySelector(".product-details[attr-prod-id]");
    const shopProductId = document.querySelector(".shop_product_id");
    if (!productDetails && !shopProductId) {
        return;
    }
    if (event.target.matches("select.bundle_option_select")) {
        const attrElement = event.target;
        const attrName = attrElement.getAttribute("attr-name");

        // Special handling for Piston Set -> Piston Ring Set (auto-suggestion)
        if (attrName === "Piston Set") {
            let pistonSet = attrElement.value;
            
            if (pistonSet && pistonSet !== "") {
                const pistonRingSetElement = document.querySelector('.bold_option_element select[attr-name="Piston Ring Set"]');
                if (pistonRingSetElement) {
                    // Convert "Piston Set" option to corresponding "Piston Ring Set" option
                    let pistonRingSet = pistonSet.replace("Piston", "Piston Ring");
                    
                    // Check if the corresponding option exists in Piston Ring Set dropdown
                    const optionExists = Array.from(pistonRingSetElement.options).some(opt => opt.value === pistonRingSet);
                    if (optionExists) {
                        // Only update if it's different from current selection
                        if (pistonRingSetElement.value !== pistonRingSet) {
                            pistonRingSetElement.value = pistonRingSet;
                            
                            // Add a visual indicator that this was auto-selected
                            pistonRingSetElement.style.backgroundColor = '#f0f8ff';
                            setTimeout(() => {
                                pistonRingSetElement.style.backgroundColor = '';
                            }, 2000);
                            
                            // Trigger change event to update hidden fields
                            pistonRingSetElement.dispatchEvent(new Event('change', { bubbles: true }));
                            
                        }
                    } else {
                        // Reset Piston Ring Set to empty if no matching option exists
                        if (pistonRingSetElement.value !== "") {
                            pistonRingSetElement.value = "";
                            pistonRingSetElement.dispatchEvent(new Event('change', { bubbles: true }));
                        }
                    }
                }
            } else {
                // If Piston Set is cleared, also clear Piston Ring Set
                const pistonRingSetElement = document.querySelector('.bold_option_element select[attr-name="Piston Ring Set"]');
                if (pistonRingSetElement && pistonRingSetElement.value !== "") {
                    pistonRingSetElement.value = "";
                    pistonRingSetElement.dispatchEvent(new Event('change', { bubbles: true }));
                }
            }
        }

        // Update bundle hidden fields when options change
        updateBundleHiddenFields();
        
        // Smart validation: Clear errors when all options are selected
        validateBundleOptionsRealTime();
    }
});

function updateBundleHiddenFields() {
    // Get product ID from attr-prod-id or shop_product_id input
    const productInfo = document.querySelector(".product-details[attr-prod-id]");
    const shopProductIdInput = document.querySelector(".shop_product_id");
    
    var parentBundleId = null;
    if (productInfo) {
        parentBundleId = productInfo.getAttribute("attr-prod-id");
    } else if (shopProductIdInput) {
        parentBundleId = shopProductIdInput.value;
    }
    
    if (!parentBundleId) return;
    
    const bundleData = option_data_fields_arr[parentBundleId];
    
    if (!bundleData || !bundleData.bundle_options || !bundleData.bundle_options[0]) return;
    
    const optionsData = bundleData.bundle_options[0].options;
    let shopProductId = parseInt(parentBundleId);
    
    let nameAttributes = [];
    let productAttributes = [];
    let varientAttributes = [];
    let qtyAttributes = [];
    let priceAttributes = [];
    let productFeaturesHtml = "";

    // Process each select element (use data-qty from Bundle Item Quantity when present)
    document.querySelectorAll(".bold_option_element select").forEach((selectElement, index) => {
        const selectedOption = selectElement.options[selectElement.selectedIndex];
        
        if (selectedOption && selectedOption.value) {
            const variantId = selectedOption.getAttribute('data-variant-id');
            const productId = selectedOption.getAttribute('data-product-id');
            const price = selectedOption.getAttribute('data-price');
            const qty = selectedOption.getAttribute('data-qty') || '1';
            
            if (variantId && productId) {
                productFeaturesHtml += "<li>" + selectedOption.value + "</li>";
                nameAttributes.push(selectedOption.value);
                productAttributes.push(productId);
                varientAttributes.push(variantId);
                qtyAttributes.push(qty);
                shopProductId += parseInt(variantId);
                priceAttributes.push(price ? price.toString().replace(".", "") : "0");
            }
        }
    });

    // Process hidden inputs (for single variant options; use data-qty when present)
    document.querySelectorAll('input[type="hidden"][data-variant-id]').forEach((hiddenInput) => {
        const variantId = hiddenInput.getAttribute('data-variant-id');
        const productId = hiddenInput.getAttribute('data-product-id');
        const price = hiddenInput.getAttribute('data-price');
        const qty = hiddenInput.getAttribute('data-qty') || '1';
        
        if (variantId && productId) {
            productFeaturesHtml += "<li>" + hiddenInput.value + "</li>";
            nameAttributes.push(hiddenInput.value);
            productAttributes.push(productId);
            varientAttributes.push(variantId);
            qtyAttributes.push(qty);
            shopProductId += parseInt(variantId);
            priceAttributes.push(price ? price.toString().replace(".", "") : "0");
        }
    });

    // Join arrays
    const nameAttributesStr = nameAttributes.length > 0 ? nameAttributes.join(",").trim() : "";
    const productAttributesStr = productAttributes.length > 0 ? productAttributes.join(",").trim() : "";
    const varientAttributesStr = varientAttributes.length > 0 ? varientAttributes.join(",").trim() : "";
    const qtyAttributesStr = qtyAttributes.length > 0 ? qtyAttributes.join(",").trim() : "";
    const priceAttributesStr = priceAttributes.length > 0 ? priceAttributes.join(",").trim().replace(".", "") : "";

    // Update hidden fields
    const boldOptionTotal = document.querySelector(".bold_option_total");
    if (boldOptionTotal) {
        const totalHtml = `
            <input type="hidden" name="properties[_boldVariantNames]" data-property-name="_boldVariantNames" value="${nameAttributesStr}">
            <input type="hidden" name="properties[_boldVariantIds]" data-property-name="_boldVariantIds" value="${varientAttributesStr}">
            <input type="hidden" name="properties[_boldProductIds]" data-property-name="_boldProductIds" value="${productAttributesStr}">
            <input type="hidden" name="properties[_boldVariantPrices]" data-property-name="_boldVariantPrices" value="0">
            <input type="hidden" name="properties[_boldVariantQtys]" data-property-name="_boldVariantQtys" value="${qtyAttributesStr}">
            <input type="hidden" name="properties[_boldBuilderId]" data-property-name="_boldBuilderId" value="${shopProductId}">
        `;
        boldOptionTotal.innerHTML = totalHtml;
    }

    // Update product features list
    const productFeaturesList = document.querySelector(".product-features ul");
    if (productFeaturesList) {
        productFeaturesList.innerHTML = productFeaturesHtml;
    }
}

// Real-time validation function for product page
function validateBundleOptionsRealTime() {
    const bundleOptions = document.querySelector('.bold_option_set');
    if (!bundleOptions) return;

    const dropdownItems = bundleOptions.querySelectorAll('.bold_option_element select');
    if (dropdownItems.length === 0) return;

    // Check if all required visible options are selected (ignore hidden single-variant dropdowns)
    const visibleSelects = Array.from(dropdownItems).filter(select => {
        const parentDiv = select.closest('.bold_option');
        return parentDiv && parentDiv.style.display !== 'none';
    });
    
    // For visible single-variant options that should be required, check if they're selected
    const allSelected = visibleSelects.every(select => {
        // If it's a visible single-variant option with only one choice, it should be auto-selected
        const allOptions = Array.from(select.querySelectorAll('option'));
        const nonEmptyOptions = allOptions.filter(option => option.value.trim() !== '');
        
        if (nonEmptyOptions.length === 1) {
            // Auto-select the single option if not already selected
            if (select.value.trim() === '') {
                select.value = nonEmptyOptions[0].value;
            }
            return true; // Single option is considered valid
        }
        return select.value.trim() !== '';
    });

    if (allSelected) {
        // All options selected - clear any existing error messages
        const existingErrors = bundleOptions.querySelectorAll('.required-error');
        existingErrors.forEach(error => error.remove());
        
        // Remove red border styling from all visible selects
        visibleSelects.forEach(select => select.classList.remove('required-border'));
        
    } else {
        // Not all visible options selected - add red border to empty visible selects (but don't show error message yet)
        visibleSelects.forEach(select => {
            if (select.value.trim() === '') {
                select.classList.add('required-border');
            } else {
                select.classList.remove('required-border');
            }
        });
    }
}

// Add to Cart button validation for bundle products (only on click)
const ProductATCbuttons = document.querySelectorAll('.product-form--atc-button');

ProductATCbuttons.forEach((button) => {
    button.addEventListener('click', function(e) {
        const bundleOptions = document.querySelector('.bold_option_set');
        if (!bundleOptions) {
            return; // No bundle options, allow normal submission
        }

        let isBlank = false;
        const dropdownItems = bundleOptions.querySelectorAll('.bold_option_dropdown select');

        // Clear existing errors and borders first
        const existingErrors = bundleOptions.querySelectorAll('.required-error');
        existingErrors.forEach(error => error.remove());

        dropdownItems.forEach((item) => {
            item.classList.remove('required-border'); // Remove any existing borders
            if (item.value === '') {
                isBlank = true;
                item.classList.add('required-border');
            }
        });

        if (isBlank) {
            e.preventDefault();
            e.stopPropagation();
            // Only show error when user clicks and validation fails
            const errorMessage = document.createElement('p');
            errorMessage.classList.add('required-error');
            errorMessage.textContent = 'Please select an option';
            bundleOptions.prepend(errorMessage);
        }
    });
});

